import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigurationService } from 'src/app/core/services/app-configuration.service';
import { DiscountTotal } from '../models/discounttotal.model';

@Injectable({
    providedIn: 'root'
})
export class DiscountTotalService {

    private apiURL : string;

    constructor(private http: HttpClient, private appConfigurationService: AppConfigurationService) {

        this.apiURL = this.appConfigurationService.baseApi + '/discounttotal';

    }

    public getByEdition(editionId: number) {

        const url = `${this.apiURL}/edition/${editionId}`;
        return this.http.get<DiscountTotal[]>(url);

    }

}
